import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = { class: "buttons" }

import { VueFinalModal } from "vue-final-modal";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  props: {
  text: String,
  confirmText: String
},
  emits: ["confirm", "close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "dialog-modal",
    "content-class": "dialog-modal-content",
    "content-transition": "vfm-slide-up"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(props.text), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = () => emit('close'))
          }, "Cancel"),
          _createElementVNode("button", {
            class: "accent",
            onClick: _cache[1] || (_cache[1] = () => emit('confirm'))
          }, _toDisplayString(props.confirmText), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})